import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';
import Slider from 'rc-slider';
import Legend from './Legend';
import config from '../config';

const styles = () => ({
  Controls: {
    padding: '2px',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  SliderWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '150px',
    marginLeft: '15px',
    marginRight: '15px',
    marginTop: '3px',
  },
});

export function Controls(props) {
  const { onYearWidthChange, classes } = props;
  return (
    <div className={classes.Controls}>
      <Legend />
      <div className={classes.SliderWrapper}>
        <Typography style={{ fontSize: '0.85em', marginRight: '12px' }}>
          {'Zoom:'}
        </Typography>
        <Slider
          defaultValue={config.YEAR_WIDTH}
          min={33}
          max={220}
          onAfterChange={onYearWidthChange}
          railStyle={{ backgroundColor: '#DDDDDD' }}
          trackStyle={{ backgroundColor: '#ae1704' }}
          handleStyle={{ borderColor: '#ae1704' }}
        />
      </div>
    </div>
  );
}

Controls.propTypes = {
  classes: PropTypes.shape().isRequired,
  onYearWidthChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(Controls);



// WEBPACK FOOTER //
// ./src/components/lifeline/Controls/Controls.jsx